<template>
  <div :class="$style.intro">
    <div v-for="(el, index) in data" :key="index">
      <div
        v-if="activeIndex === index"
        :class="[$style.intro_item, animated && $style.animated]"
      >
        <the-game-gallery-intro :data="el" />
      </div>
    </div>
  </div>
</template>

<script>
import TheGameGalleryIntro from './TheGameGalleryIntro'

export default {
  components: { TheGameGalleryIntro },
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
    activeIndex: { type: Number, default: null },
  },
  data() {
    return { animated: false }
  },
  mounted() {
    this.animated = true
  },
}
</script>

<style lang="less" module>
.intro {
  @intro-left: 2.62rem;
  @intro-width: 3.64rem;

  position: absolute;
  top: @padding-base;
  left: @intro-left;
  width: @intro-width;

  @media screen and (max-width: @laptop-width) {
    left: @intro-left - 1;
    width: @intro-width + 1;
  }

  @media screen and (max-width: @mini-width) {
    left: @intro-left - 1.5;
    width: @intro-width + 1.5 + 2; // 加 2 的宽度是因为去掉了浮动导航
  }

  &_item {
    display: none;
  }
}

.animated {
  display: block;
  animation: introFadeIn 1.5s both;
}

@keyframes introFadeIn {
  from {
    opacity: 0;
    transform: translate3d(20%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>
